import api from './api';

export const messageService = {
  getRooms: async () => {
    const response = await api.get('/messages/rooms/');
    return response.data;
  },

  createRoom: async (chimneyId) => {
    const response = await api.post('/messages/rooms/create_room/', {
      chimney: chimneyId,
    });
    return response.data;
  },

  getMessages: async (roomId) => {
    const response = await api.get(`/messages/rooms/${roomId}/messages/`);
    return response.data;
  },

  sendMessage: async (roomId, content) => {
    const response = await api.post(`/messages/rooms/${roomId}/messages/`, {
      content,
    });
    return response.data;
  },
};
